export default "__VITE_ASSET__BkpWS$YV__"